import {jwtDecode} from 'jwt-decode'

const decodeJWT = (jwt:string) => {
  const decodedJWT = jwtDecode(jwt);
  return decodedJWT;
}

export default decodeJWT